import { defaultSchoolYearClass, ISchoolYearClass } from "features/setup/models/SchoolYear"
import { IRegistration } from "./Registration";

export interface IRegistrationMark {
    id: number,

    status: 'N' | 'C' | 'E' | 'M',

    registrationId: number,
    schoolYearTemplateSubjectExamScheduleId: number,
    mark: number,
    

    currentMark: number,
    rank: number,
    markExist: boolean,
    markPurpose: string,
    markAppreciationId: number,

    isSubjectExcluded: boolean,

    registrationMarkCompetences: IRegistrationMarkCompetence[],

    firstName: string,
    lastName: string,
    birthDate: Date,          

    fullNameFR: string,
    fullNameEN: string
}

export interface IRegistrationTypeMark {
    id: number, // registrationExamId or registrationPeriodId or registrationAnnualId
    appreciationName: string,
    successed: boolean,

    schoolYearClassName: string,
    schoolYearName: string,
    studentNameFR: string,
    studentNameEN: string,

    averageMark: number,

	averageMarkAppreciationId: number,
	rank: number,
}

export interface IRegistrationMarkCompetence {
    id: number,

    registrationMarkId: number,

    status: 'N' | 'C' | 'E' | 'M',

    currentMark: number,

    maxMark: number,

    mark: number,
    rank: number,
    markExist: boolean,
    markPurpose: string,
    markAppreciationId: number,

    schoolYearTemplateSubjectExamScheduleCompetenceId: number,
    schoolYearTemplateSubjectCompetenceDescription: string,

    schoolYearTemplateSubjectExamScheduleId: number,
    schoolYearTemplateSubjectCompetenceId: number,

    schoolYearTemplateSubjectCompetenceTitle: string, // for manage file upload only
    firstName: string, // for manage file upload only
    lastName: string, // for manage file upload only
    
}

export interface ISchoolYearClassSubjectMark {
    id: number,

    schoolYearTemplateSubjectExamScheduleId: number,

    schoolYearClassId: number,
    schoolYearClassName: string,
    studyType: string,
    schoolYearClassTemplateId: number,

    fullTeacherName: string,
    substituteTeacherName: string,
    classTemplateName: string, 
    studyLanguage: string,
    studyLevel: string,

    schoolYearId: number,
    schoolYearStartDate: Date,
    schoolYearEndDate: Date,

    schoolYearPeriodId: number,
    schoolYearPeriodExamId: number,

    schoolYearClassSubjectId: number,
    teacherName: string,
    schoolYearTemplateSubjectLongName: string,

    maxMark: number,
    schoolYearClassSubjectExamScheduleStatus: string,

    checkMarkByCompetence: boolean,
    autoDistributeMarkByCompetence: boolean,

    registrationMarks: IRegistrationMark[]
}


export interface IRegistrationReportCard {

    registrationId: number,

    schoolYearPeriodExamId: number,
    schoolYearPeriodId: number,

    reportCard: string,
    
    averageMark: number,
    averageMarkAppreciationId: number,
    rank: number,       
}

export type ReportCardType = 'exam' | 'period' | 'year';

export interface ISchoolYearClassReportCard {

    id: number,

    schoolYearClass: ISchoolYearClass,

    type: ReportCardType,

    schoolYearId: number,
    schoolYearStartDate: Date,
    schoolYearEndDate: Date,

    schoolYearPeriodId: number,
    schoolYearPeriodExamId: number,

    studyType: string,
    studySection: string,
    studyLanguage: string,
    studyLevel: string,
    studyCycle: string,
    schoolYearClassTemplateId: number,
    schoolYearClassId: number,

    reportCard: string,

    registrationReportCards: IRegistrationReportCard[]
}

export interface IMarkDashboard {

    schoolYearId: number,
    schoolYearPeriodId: number,
    schoolYearPeriodExamId: number,

    schoolYearStartDate: Date,
    schoolYearEndDate: Date,
    
    reportCard: string,

    classOrder: number,
    studyType: string,
              
    studySection: string,
    studyLanguage: string,
    studyCycle: string,
    studyLevel: string,
    
    schoolYearClassTemplateId: number,
    schoolYearClassId: number,    

    filterUpToDateRegistration: boolean,
    filterUpToDateDueDate: Date,

    sortBy: string,

    registrationId: number,
    
    averageMark: number
}

export const defaultMarkDashboard : IMarkDashboard = {

    schoolYearId: 0,
    schoolYearPeriodId: 0,
    schoolYearPeriodExamId: 0,

    schoolYearStartDate: new Date(),
    schoolYearEndDate: new Date(),
    
    reportCard: '',
    
    classOrder: 0,
    studyType: '',
              
    studySection: '',
    studyLanguage: '',
    studyCycle: '',
    studyLevel: '',
    
    schoolYearClassTemplateId: 0,
    schoolYearClassId: 0,   

    filterUpToDateRegistration: false,
    filterUpToDateDueDate: new Date(),

    sortBy: '',

    registrationId: 0,
    
    averageMark: 0  
}



export const defaultRegistrationMark : IRegistrationMark = {
    id: 0,

    status: 'N',
    
    registrationId: 0,
    schoolYearTemplateSubjectExamScheduleId: 0,
    currentMark: 0,
    mark: 0,
    rank: 0,

    markExist: true,
    markPurpose: '',
    markAppreciationId: 0,

    isSubjectExcluded: false,

    registrationMarkCompetences: [],

    firstName: '',
    lastName: '',
    birthDate: new Date(),

    fullNameFR: '',
    fullNameEN: ''
}

export const defaultSchoolYearClassSubjectMark : ISchoolYearClassSubjectMark = {
    id: 0,
    schoolYearTemplateSubjectExamScheduleId: 0,

    schoolYearClassId: 0,
    schoolYearClassName: '',
    studyType: '',
    schoolYearClassTemplateId: 0,

    fullTeacherName: '',
    substituteTeacherName: '',
    classTemplateName: '', 
    studyLanguage: '',
    studyLevel: '',

    schoolYearId: 0,

    schoolYearStartDate: new Date(),
    schoolYearEndDate: new Date(),

    schoolYearPeriodId: 0,
    schoolYearPeriodExamId: 0,

    schoolYearClassSubjectId: 0,
    teacherName: '',
    schoolYearTemplateSubjectLongName: '',

    maxMark: 20,    
    schoolYearClassSubjectExamScheduleStatus: '00',

    checkMarkByCompetence: false,
    autoDistributeMarkByCompetence: false,

    registrationMarks: []
}

export const defaultSchoolYearClassReportCard : ISchoolYearClassReportCard = {
    id: 0,

    schoolYearClass: defaultSchoolYearClass,

    type: 'period',

    schoolYearId: 0,
    schoolYearStartDate: new Date(),
    schoolYearEndDate: new Date(),

    schoolYearPeriodId: 0,
    schoolYearPeriodExamId: 0,

    studyType: '',
    studySection: '',
    studyLanguage: '',
    studyLevel: '',
    studyCycle: '',
    schoolYearClassTemplateId: 0,
    schoolYearClassId: 0,

    reportCard: '',

    registrationReportCards: []
}

export const defaultRegistrationMarkCompetence : IRegistrationMarkCompetence = {

    id: 0,

    registrationMarkId: 0,

    status: 'N',

    currentMark: 0,

    maxMark: 0,

    mark: 0,
    rank: 0,
    markExist: true,
    markPurpose: '',
    markAppreciationId: 0,

    schoolYearTemplateSubjectExamScheduleCompetenceId: 0,
    schoolYearTemplateSubjectCompetenceDescription: '',

    schoolYearTemplateSubjectExamScheduleId: 0,
    schoolYearTemplateSubjectCompetenceId: 0,

    schoolYearTemplateSubjectCompetenceTitle: '', // for manage file upload only
    firstName: '', // for manage file upload only
    lastName: '', // for manage file upload only
    
}



export interface IRegistrationMarkSearch {
    firstName: string,
    lastName: string,        
  }
